import { ChartSettingsT, PivotFieldsAggridT } from 'business/definitions';
import { useMutation } from '@tanstack/react-query';
import { RQAPICall } from 'store/APIClient';

const updateSettings = ({
    chartSettings,
    pivotFieldsAggrid,
    chartKey,
}: {
    chartSettings: ChartSettingsT;
    pivotFieldsAggrid: PivotFieldsAggridT;
    chartKey: number;
}) => {
    if (pivotFieldsAggrid == null) {
        // check to prevent erasure of TCD settings
        // this shouldn't occur, but we never know ...
        console.error(
            'Update argument chart pivot fields settings error, cannot write empty col defs',
        );
    }

    const updatedSettings = { ...chartSettings, pivotFieldsAggrid };

    return RQAPICall({
        endpoint: `explore/chart/${chartKey}`,
        body: { settings: updatedSettings },
        method: 'PUT',
    });
};

export function useMutateArgumentPivotGridSettings(chartKey: number): {
    mutate: ({
        chartSettings,
        pivotFieldsAggrid,
    }: {
        chartSettings: ChartSettingsT;
        pivotFieldsAggrid: PivotFieldsAggridT;
    }) => void;
} {
    const mutation = useMutation({
        mutationFn: ({
            chartSettings,
            pivotFieldsAggrid,
        }: {
            chartSettings: ChartSettingsT;
            pivotFieldsAggrid: PivotFieldsAggridT;
        }) => updateSettings({ chartSettings, pivotFieldsAggrid, chartKey }),

        meta: {
            useGlobalOnError: true,
        },
    });
    return mutation;
}
